import React from 'react'
import { Link, useParams } from 'react-router-dom'
import styles from './WithdrawDetails.module.sass'

const timeline = [
  {
    id: 'request-submitted',
    title: 'Withdrawal Request Submitted',
    meta: '2026-04-09 10:40:16',
    status: 'done',
  },
  {
    id: 'system-confirmation',
    title: 'System Confirmation',
    meta: '2026-04-09 10:41:35',
    status: 'done',
  },
  {
    id: 'block-confirmation',
    title: 'Block Confirmation',
    meta: '3 min left',
    status: 'active',
    progress: 0.58,
  },
  {
    id: 'done',
    title: 'Done',
    meta: `You'll be notified via SMS or email on the successful transaction. (Please check your spam folder if you do not receive the email.)`,
    status: 'pending',
  },
]

const WithdrawDetailsOverview = () => {
  const { id } = useParams()

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div>
            <h1 className={styles.amount}>8078.224278 USDT</h1>
            <div className={styles.badge}>
              <span className={styles.badgeIcon} />
              <span>Under Block Confirmation</span>
            </div>
            <p className={styles.reference}>Withdrawal ID: {id}</p>
          </div>

          <Link to="/withdraw" className={styles.historyButton}>
            Withdrawal History
          </Link>
        </div>

        <div className={styles.divider} />

        <div className={styles.timeline}>
          {timeline.map((item, index) => {
            const isLast = index === timeline.length - 1
            const isDone = item.status === 'done'
            const isActive = item.status === 'active'

            return (
              <div
                key={item.id}
                className={`${styles.timelineItem} ${isDone ? styles.timelineItemDone : ''} ${isActive ? styles.timelineItemActive : ''}`}
              >
                {!isLast && <span className={styles.line} />}

                <div className={styles.markerWrap}>
                  <span className={`${styles.marker} ${isDone ? styles.markerDone : ''}`}>
                    {isDone ? 'v' : index + 1}
                  </span>
                </div>

                <div className={styles.content}>
                  <div className={styles.titleRow}>
                    <h2 className={styles.title}>{item.title}</h2>

                    {isActive && typeof item.progress === 'number' ? (
                      <span className={styles.progressTrack}>
                        <span
                          className={styles.progressValue}
                          style={{ width: `${item.progress * 100}%` }}
                        />
                      </span>
                    ) : null}
                  </div>

                  <p className={styles.meta}>{item.meta}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default WithdrawDetailsOverview
